<template>
  <div id="inicio">
    
    <article class="row">
        
        <div class="logo one-third column grande"><img src="/img/home-marca.svg"></div>
        <div class="two-thirds imagen column grande">
          <ul >
            <li><div><a href="#nosotros">Nosotros</a></div></li>
            <li><div><a href="#servicios">Servicios</a></div></li>
            <li><div style="margin-top: -10px"><a href="#basculas">Basculas y soluciones</a></div></li>
            <li><div><a href="#contacto">Contacto</a></div></li>
          </ul>
        </div>
        <div class="imagen chico logo">
          <img src="/img/home-marca.svg">
        </div>
        <div class="topnav chico">
            <div id="myLinks">
              <a href="#nosotros">Nosotros</a>
              <a href="#servicios">Servicios</a>
              <a href="#basculas">Basculas y soluciones</a>
              <a href="#contacto">Contacto</a>
            </div>
            <!-- "Hamburger menu" / "Bar icon" to toggle the navigation links -->
            <a href="#" @click="cambiar">
              <img src="/img/hamburger.svg"/>
            </a>
          </div>
        <div class="titulo">
          <h1>SERVICIO TECNICO </h1>
          <h2>BASCULAS PARA CAMIONES, TRENES, INDUSTRIA Y OTROS</h2>
        </div>
        
        <div class="iconos-home grande">
          <a target="_blank" href="https://wa.me/5492614708094"><img src="/img/home-iconos1.svg"/></a>
          <a target="_blank" href="mailto:info@stbalanzas.com"><img src="/img/home-iconos2.svg"/></a>
          <a target="_blank" href="#contacto"><img src="/img/home-iconos3.svg"/></a>
        
        </div>
        <div class="iconos-home chico">
          <a target="_blank" href="https://wa.me/5492614708094"><img src="/img/home-iconos1w.svg"/></a>
          <a target="_blank" href="mailto:info@stbalanzas.com"><img src="/img/home-iconos2w.svg"/></a>
          <a target="_blank" href="#contacto"><img src="/img/home-iconos3w.svg"/></a>
        
        </div>
    </article>
  </div>
</template>

<script>
export default {
  methods:{
    cambiar(){
      var x = document.getElementById("myLinks");
      if (x.style.display === "block") {
        x.style.display = "none";
      } else {
        x.style.display = "block";
      }
    }
  }

}
</script>


<style >
  #inicio .chico{
    display: none;
  }
  #inicio a{
    text-decoration: none;
  }
  #inicio{
    background: linear-gradient(to left, #478CCF 50%, #fff 50%);    
    background-repeat: no-repeat;
    background-position: 60% 0;
    position: relative;
    
  }
  #inicio .imagen{
    background-image: url('/img/home2.jpeg');
    min-height: 600px;
    padding-top: 50px;
    background-repeat: no-repeat;
    background-size: cover;
  }
  #inicio li {
    display: inline-block;
    padding:  5px 15px;
    border-left: solid 2px #fff;
    
    line-height: 1;
    height: 20px;
    vertical-align: middle;
  }
  #inicio li div {
    
    padding:  0;
    width: 80px;
    line-height: 1;
    vertical-align: top;
  }
  #inicio li:last-child {
    border-right: solid 2px #fff;
  }
  #inicio h1{
    color: #004A99;
    font-size: 90px;
    margin-bottom: 0;
    line-height: 1;
  }
  #inicio h2{
    color: #fff;
    font-size: 20px;
    text-align: center;
  }
  #inicio li a{
    color: #fefefe;
    font-weight: lighter;
    text-transform: uppercase;
    font-size: 17px

  }
  #inicio ul{
    display: inline-block;
    margin-left:  40px;
  }
  .logo{
    display: inline-block;
    padding-top: 50px;
    text-align: right;
  }
  .logo img{
      
  }
  #inicio article{
    
  }
  #inicio .titulo{
    position: absolute;
    top: 50%;
    left: 25%;
    right: 5%;
  }
  .iconos-home{
    bottom: 5%;
    position: absolute;
    left: 10%;
  }
  .iconos-home a{
    display: block;
    margin-top: 10px;
  }
  @media screen and (max-width: 700px) {
    #inicio .grande{
      display: none
    }
    #inicio h1{
      color: #fff;
      font-size: 40px;
      margin-bottom: 0;
      line-height: 1;
    }
    #inicio .chico{
      display: block;
    }
    #inicio .chico.logo{
      
      padding-top: 50px;
      text-align: center;
    }
    
  }

   /* Style the navigation menu */
.topnav {
  overflow: hidden;
  background-color: #333;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1000;
}

/* Hide the links inside the navigation menu (except for logo/home) */
.topnav #myLinks {
  display: none;
}

/* Style navigation menu links */
.topnav a {
  color: white;
  padding: 2px;
  text-decoration: none;
  display: block;
}

/* Style the hamburger menu */
.topnav a.icon {
  background: black;
  display: block;
  position: absolute;
  right: 0;
  top: 0;
}

/* Add a grey background color on mouse-over */
.topnav a:hover {
  background-color: #ddd;
  color: black;
}

/* Style the active link (or home/logo) */
.active {
  color: white;
} 

  
</style>